import { AGENT_IDS, DATA_CATALOG_API_TOOL_IDS } from '@/app/data-catalog/_common/constants'
import { useApiRequest } from '@/lib/http-utils'
import { useQuery } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'
import { TagsStructure } from './use-table-details-query'

export type Table = {
  table_name: string
  table_domain: string
  table_description: string
  table_owners: string[]
  table_version: number
  row_count: number | null
  column_count: number | null
  all_columns: string[]
  tags: TagsStructure
}

export type TablesAPIResponse = {
  service_name: string
  database_source: string
  database_name: string
  schema_name: string
  schema_description: string
  schema_owners: string[]
  tables: Table[]
}

export type TablesQueryParams = {
  service_name: string
  database_name: string
  schema_name: string
  assetType?: string
}

export function useTablesQuery(params: TablesQueryParams) {
  const agentId = AGENT_IDS.DATA_CATALOG_AGENT
  const { apiRequest, domainId } = useApiRequest()

  return useQuery<TablesAPIResponse>({
    queryKey: ['tables', params.service_name, params.database_name, params.schema_name],
    queryFn: async () => {
      const basePath = taskManagerApiPaths.agentById({ domainId, agentId })

      const response = await apiRequest({
        path: basePath,
        queryParams: {
          tool_id: DATA_CATALOG_API_TOOL_IDS.FETCH_ALL_TABLES,
        },
        options: {
          method: 'POST',
          body: JSON.stringify({
            catalogSelector: {
              service_name: params.service_name,
              database_name: params.database_name,
              schema_name: params.schema_name,
            },
          }),
        },
      })

      if (!response.ok) {
        throw new Error('Error fetching tables')
      }

      const json = (await response.json()) as { output: TablesAPIResponse }
      return json.output
    },
  })
}
